/** All available column fields for the teams table */
export const TEAMS_TABLE_COLUMNS = ["name", "users", "creationDate", "workspaceRole", "options"];

/** The labels for the columns in the teams table */
export const TEAMS_TABLE_COLUMN_LABELS = {
  name: "Team name",
  users: "Members",
  creationDate: "Creation date",
  workspaceRole: "Workspace role",
  options: "Options"
};

/** Sortable column fields for the teams table */
export const TEAMS_SORTABLE_FIELDS = ["name", "users", "creationDate", "workspaceRole"];

/** The labels for the sortable teams columns */
export const TEAMS_SORT_COLUMN_LABELS = {
  name: "Team name",
  users: "Members",
  creationDate: "Creation date",
  workspaceRole: "Workspace role"
};